<template>
	<div class="py-5 px-5">
		<div class="bg-white rounded-md p-3">
			<h1>Oops, it looks like the page you're looking for doesn't exist.</h1>
		</div>
	</div>
</template>
